var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"content-placeholder"},[(_vm.loading)?_c('v-progress-circular',{staticClass:"content-placeholder__loading",attrs:{"size":36,"width":3,"indeterminate":"","color":"grey lighten-1"}}):_c('v-icon',{staticClass:"spin",attrs:{"size":"90","color":"grey lighten-1"}},[_vm._v(_vm._s(_vm.icon))]),_c('h1',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }